import { MEDIA_QUERIES } from "context/media/MediaConstant";
import styled from "styled-components";

export const StyledHeader = styled.div`
  width: 100%;
  min-height: 65px;

  display: flex;
  position: sticky;

  top: 0;
  justify-content: space-between;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.headerRed};
  z-index: 3;

  @media ${MEDIA_QUERIES.MOBILE} {
    min-height: 48px;
    width: 100%;
  }
`;

interface LogoWrapperProps {
  isLoginScreen: boolean;
}
export const LogoWrapper = styled.div<LogoWrapperProps>`
  width: ${({ isLoginScreen }) => (isLoginScreen ? "auto" : "870px")};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: ${({ isLoginScreen }) => (isLoginScreen ? "20px" : "0")};

  @media ${MEDIA_QUERIES.MOBILE} {
    margin-left: 20px;
  }
`;

export const StyledLang = styled.div`
  color: ${({ theme }) => theme.colors.secondaryAkbankWhite};
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: 2px;
  font-weight: bold;
  padding-right: 20px;

  & a {
    cursor: pointer;
  }
`;
